<template>
  <div v-if="item.items && item.items.length > 0" class="summary">
    <slot></slot>
    <div class="wrapper border-top mt-4 pt-2">
      <template v-for="(item, index) in item.items">
        <div :key="key(index, 1)" :class="{ 'pb-2': isLastItem(index) }">
          {{ $t(item.item) }}
        </div>       
        <div :key="key(index, 2)" class="text-right mul-op pl-0">
          {{ item.qty }}
        </div>
        <div :key="key(index, 3)" class="text-center text-secondary">
          x
        </div>         
        <div :key="key(index, 4)" class="text-right">
          {{ item.price }}
        </div>
        <div :key="key(index, 5)" class="text-right">
          {{ item.amount }}
        </div>
      </template>
      <div class="subtotal border-top mt-2 pt-2"></div>
      <template v-if="item.subtotal">
        <div class="sub-text text-right">{{ $t('license.slot.summary.subtotal') }}</div>
        <div class="sub-number text-right">${{ item.subtotal }}</div>
      </template>
      <template v-if="item.min_price">
        <div class="sub-text text-right">{{ $t('license.slot.summary.min_charge') }}</div>
        <div class="sub-number text-right">${{ item.min_price }}</div>
      </template>
      <template class="total">
        <div class="sub-text text-right" v-html="$t('license.slot.summary.total')"></div>
        <div class="sub-number text-right">${{ item.price }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryView",
  components: {},
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  methods: {
    key: function (index, s) {
      return index + "_" + s;
    },
    isLastItem: function(index) {
      return this.item && this.item.items && index != this.item.items.length - 1
    }
  },
  computed: {},
};
</script>

<style>
.summary .wrapper {
  display: grid;
  grid-template-columns: auto 1em 1em 2.2em 2.5em;
  color: #495057;
}
.modal-body .summary .wrapper {
  grid-template-columns: auto 2em 1em 3em 3em;
}
.summary .wrapper .subtotal {
  grid-column-start: 1;
  grid-column-end: 6;
}
.summary .wrapper .sub-text {
  grid-column-start: 1;
  grid-column-end: 5;
}
@media screen and (min-width: 768px) {
  .summary .wrapper {
    grid-template-columns: auto 2em 1em 4em 4em;
  }
}
@media screen and (min-width: 992px) {
  .summary .wrapper {
    grid-template-columns: auto 2em 1em 5em 5em;
  }
}
.summary .mul-op {
  position: relative;
}

</style>